/**
 * Storage for session information.
 */
import React, { useReducer, createContext } from "react";

export const SessionContext = createContext();

const initialState = {
  userid: 0, //Temp:1 //Default 0
  aid: 0,//Temp:1 //Default 0
  ident: '',  //Temp: Dx6zYzyvuTP4rXAGdu~z //Default ''
  isActive: false, //Temp:true  //Default false
  copyright:'',
  blayer : 'os10k', //osmm,osmmbw,os10k,os25k,os50k,os250k,aerial
  viewScale: 7500,
  addresses: [], //Stores result of address search
  address: {}, //Stores the user selected address
  dlayer: [],
  dlayerChange: {layer:'', action:'add'},
  dlayerList: [],
  doInfoQuery: true,
  doInfoDisabled: false,
  mapArea: '', //Displays the map area value in ha or km.
  mapAreaUnits: 'ha', //Displays the map area value in ha or km.
  mapextent:[], //Stores the current mapextent.
  layerInformation:[], //Stores the layer information for querries.
  mapAnnotations:[], //Stores the map annotations
  measurementUnits:{area:'km', length:'km'},
  annotationSelected: 'none',
  annotationStyle: { outline:{colour: 'rgb(244,67,54)', width: 3}, fill:{colour: 'rgba(244,67,54,0)'}, source: 'none'},
  textAnnotation: { text:'', font:'', outline:{colour: 'rgb(105,105,105)', width: 3}, fill:{colour: 'rgba(255,255,255,1)'}, source: 'none'},
  dbAnnotation:'', //Annotation requested from database. i.e. OSMM building outline
  projectreference:'',
  userreference:'',
  orderid: 0, //Current orderid of processing item. i.e. print / data etc..
  balance: 0, //Session balance
  monthlybalance: 0, //Session balance
  print:{},
  printframeextent:[],
  printArea:0,
  hasPrintFrame: false,
  templates:[], //Stores available print templates
  data:{}, //Stores data export information.
  datageom: { geometry: 0, area: 0}, //Stores data geometry.
  report:{}, //Stores report information.
  requestdatageom: {}, //Stores information on the requested data geom.
  reportgeom: { geometry: 0, area: 0}, //Stores data geometry.
  requestreportgeom: {}, //Stores information on the requested report geom.
  caction: 'none', //Options: addressresult, print, export, displaylayers, displaytools
  viewPrice:0,
  getPrice:false,
  orderPrice:{}, //Details of order including order price.
  exportListPrice:[], //Stores a list of dataexport layers including pricing.
  reportListPrice:[], //Stores the price list for reports.
  creditReached:false,
  cInterface: '',
  projects:{}, //Stores projects list.
  orders:{}, //Stores orderlist information.
};


const reducer = (state, action) => {
  switch (action.type) {
    case "setSystemConfig":
      return { ...state, 
        copyright: action.payload.copyright,
      };
    case "create":
      return { ...state, 
        userid: action.payload.userid,
        aid: action.payload.aid,
        isActive: action.payload.isActive,
        ident: action.payload.ident
      };
      case "end":
        return { ...state, 
          userid: 0,
          aid: 0,
          ident: '', 
          blayer : 'os10k',
          viewScale: 7500,
          isActive: false,
          data:{},
          datageom: { geometry: 0, area: 0},
          print:{},
          printframeextent:[],
          mapAnnotations:[],
          caction:'logout',
      };
      case "setViewScale":
        //console.log("setViewScale called:"+action.payload.viewScale)
        return { ...state, 
          viewScale: action.payload.viewScale,
      };
      case "setBaseLayer":
        return {
            ...state, 
            blayer: action.payload.layer,
        };
      case "updatemaparea":
          return { ...state, 
            mapArea: action.payload.mapArea,
            mapAreaUnits: action.payload.mapUnit,
      };
      case "setreference":
        return { ...state, 
          projectreference: action.payload.projectreference,
          userreference: action.payload.userreference,
      };
      case "setSessionBalance":
          return {
            ...state, 
              balance: action.payload.balance,
      };
      case "setMonthlyBalance":
          return {
            ...state, 
              monthlybalance: action.payload.monthlybalance,
      };
      case "setDataLayer":
          return {
            ...state, 
              dlayer: action.payload.layers,
      };
      case "setDataLayerChange":
          return {
            ...state, 
            dlayerChange: action.payload.layerChange,
      };
      case "setDataLayerList":
        return {
          ...state, 
          dlayerList: action.payload.layers,
      };
      case "setDoInfoQuery":
        return {
          ...state,
          doInfoQuery: action.payload.doInfoQuery,
      };
      case "setDoInfoDisabled":
        return {
          ...state,
          doInfoDisabled: action.payload.doInfoDisabled,
        };
      case "setLayerInformation":
        return {
          ...state, 
          layerInformation: action.payload.layerInformation,
      };
      case "setCurrentInterface":
          return {
            ...state, 
            cInterface: action.payload.interface,
        };
      case "setUserAction":
        return {
          ...state, 
          caction: action.payload.action,
      };
      case "setViewPrice":
        return {
          ...state, 
          viewPrice: action.payload.price,
      };
      case "setOrderPrice":
        return {
          ...state, 
          orderPrice: action.payload.price,
      };
      case "setorderid":
        return { ...state, 
          orderid: action.payload.orderid
      };
      case "storeAddresses":
        return {
          ...state, 
          addresses: action.payload.addresses,
          caction: 'addressresult'
      };
      case "displayAddress":
        return {
          ...state, 
          address: action.payload.address,
          caction: 'addressdisplay'
      };
      case "settemplates":
        return { ...state, 
          templates: action.payload.templates
        };
      case "displayPrintFrame":
        return { ...state, 
          hasPrintFrame: action.payload.hasPrintFrame
        };
      case "setprint":
        return { ...state, 
          print: action.payload.print
        };
      case "getprice":
          return { ...state, 
            getPrice: action.payload.getPrice
        };
      case "setprintframe":
        return { ...state, 
          printframeextent: action.payload.extent,
          printArea:action.payload.area
        };
      case "setdata":
          return { ...state, 
            data: action.payload.data
      };
      case "setdatageom":
        return {
          ...state, 
          datageom: action.payload.datageom,
      };
      case "requestdatageom":
        return {
          ...state,
          caction: action.payload.action,
          requestdatageom: action.payload.requestdatageom,
      };
      case "setreport":
        return { ...state, 
          report: action.payload.report
      };
      case "setreportgeom":
        return {
          ...state, 
          reportgeom: action.payload.reportgeom,
      };
      case "requestreportgeom":
        return {
          ...state,
          caction: action.payload.action,
          requestreportgeom: action.payload.requestreportgeom,
      };
      case "annotationselected":
        return { ...state, 
          annotationSelected: action.payload.type,
      };
      case "setmapextent":
        return { ...state, 
          mapextent: action.payload.mapextent,
      };
      case "setmapannotation":
        return { ...state, 
          mapAnnotations: action.payload.annotations,
      };
      case "settextannotation":
        return { ...state, 
          textAnnotation: action.payload.annotations,
      };
      case "setmeasurementunits":
        return { ...state, 
          measurementUnits: action.payload.units,
      };
      case "setdbannotation":
        return { ...state, 
          dbAnnotation: action.payload.annotations,
      };
      case "setstyle":
        //console.log("action setstyle with payload:"+JSON.stringify(action.payload.style));
        return {...state,
          annotationStyle: action.payload.style,
      };
      case "setexportListPrice":
        return { ...state, 
          exportListPrice: action.payload.exportListPrice,
      };
      case "setreportListPrice":
        return { ...state, 
          reportListPrice: action.payload.listprice,
      };
      case "setorders":
        return { ...state, 
          orders: action.payload.orders,
      };
      case "creditReached":
        return { ...state, 
          creditReached: action.payload.creditReached,
      };
      case "clearmapannotation":
        return { ...state, 
          mapAnnotations: [],
      };
    default:
      throw new Error();
  }
};

export const SessionContextProvider = props => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <SessionContext.Provider value={[state, dispatch]}>
      {props.children}
    </SessionContext.Provider>
  );
};